import React from 'react';
import { Link, useParams } from '@okapi/router-react';
import { category } from '../../__mocks__/category';

// TODO: убрать этот хардкод
export const ArticlesCategory = () => {
  const params = useParams();

  return (
    <ul className="articles-type-ul">
      {category.map(item => {
        const isActive = !item.url ? !params.type : params.type === item.url;
        const adviceUrl = item.url ? `${item.url}/` : item.url;

        return (
          <li key={item.url} className="article-type-li">
            <div className={`articles-type__active ${isActive && 'article-type-active'}`} />
            <Link
              className={`article-type-link ${isActive && 'article-type-link-active'}`}
              to={`/advice/${adviceUrl}`}>
              {item.name}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
